export class PostKsjMessageFactory {
    constructor() {
        this.iframeId = ''; // iframe 标签的id
        this.callbackMap = new Map();
    }

    init(iframeId) { // iframe 标签的id
        if (!iframeId) {
            throw new Error('init初始化参数缺失 iframe Id');
        }
        this.iframeId = iframeId;
        window.addEventListener('message', this.onMessage.bind(this));
    }

    unint() {
        window.removeEventListener('message', this.onMessage.bind(this));
    }

    postMessage(data, callback) {
        if (!data.commandName) {
            throw new Error('参数对象缺失 commandName字段');
        }
        let iframe = document.getElementById(this.iframeId);
        if (!iframe) {
            throw new Error('iframe不存在, 请检查iframeId是否正确');
        }
        iframe.contentWindow.postMessage(data, "*");
        if (callback) {
            this.callbackMap.set(data.commandName, callback);
        }
    }

    onMessage(event) {
        if (event.data.commandName) {
            const data = event.data;
            const callback = this.callbackMap.get(data.commandName);
            if (callback) {
                callback(data.data);
                this.callbackMap.delete(data.commandName);
            }
        }
    }
}
